module.exports = __webpack_public_path__ + "img/1560885984.65783dd9.jpg";